import ReportsBoxColumn from "./ReportsBoxColumn";
import Loading from "../../components/Loading";
import { useSelector } from "react-redux";
import { selectReportingBoxData, selectAggregateMetrics } from "./reportSlice";
import { selectIsPending } from "../common-states/commonStatesSlice";
import { toFarsiNumber } from "../../cudtom-hooks/en-to-persian";

const ReportsBox = () => {
  const reportingBoxData = useSelector(selectReportingBoxData);
  const isPending = useSelector(selectIsPending);
  const { totalHouseholds, totalLivestock, totalDistanceKm } = useSelector(selectAggregateMetrics);

  return (
    <div className='reports-box relative flex flex-wrap border border-gray-600 rounded-xl text-xs text-gray-800 my-5'>
      <ReportsBoxColumn firstRowReport='تعداد کل درخواست ها:' data={reportingBoxData[2]} />
      <ReportsBoxColumn firstRowReport='تعداد درخواست های آب شرب:' waterType='آب شرب' data={reportingBoxData[1]} />
      <ReportsBoxColumn firstRowReport='تعداد درخواست های آب دام:' waterType='آب دام' data={reportingBoxData[0]} />

      {/* New column for extra metrics */}
      <div className='column w-full sm:w-1/2 lg:w-1/3 grow py-2 px-2 border-t lg:border-t-0 lg:border-r'>
        <div dir='rtl' className='flex justify-between mb-2'>
          <span>تعداد خانوار بهره‌مند:</span>
          <span>{toFarsiNumber(totalHouseholds)}</span>
        </div>
        <div dir='rtl' className='flex justify-between mb-2'>
          <span>تعداد دام برخوردار:</span>
          <span>{toFarsiNumber(totalLivestock)}</span>
        </div>
        <div dir='rtl' className='flex justify-between mb-2'>
          <span>مسافت طی (کیلومتر):</span>
          <span>{toFarsiNumber(totalDistanceKm)}</span>
        </div>
      </div>

      {isPending && (
        <div className='absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2'>
          <Loading />
        </div>
      )}
    </div>
  );
};

export default ReportsBox;